export interface BusinessWorkspace {
  id: 'core' | 'media' | 'assessment' | 'equipment';
  label: string;
  unified?: boolean;
  media: boolean;
  assessment: boolean;
  equipment: boolean;
}

export function businessWorkspaces(): readonly BusinessWorkspace[] {
  if (
    !import.meta.env.DEV ||
    typeof window === 'undefined' ||
    !['127.0.0.1', 'localhost'].includes(window.location.hostname)
  )
    return [];
  try {
    const value: unknown = JSON.parse(
      document.getElementById('platform-services')?.textContent ?? '{}',
    );
    if (
      !value ||
      typeof value !== 'object' ||
      !('workspaces' in value) ||
      !Array.isArray(value.workspaces)
    )
      return [];
    return value.workspaces.filter((w: unknown): w is BusinessWorkspace =>
      Boolean(
        w &&
        typeof w === 'object' &&
        'id' in w &&
        ['core', 'media', 'assessment', 'equipment'].includes(String(w.id)) &&
        'label' in w &&
        typeof w.label === 'string',
      ),
    );
  } catch {
    return [];
  }
}

/** Full page dataset changes clear all component-owned sessions and pending writes. */
export function selectedBusinessWorkspace(): BusinessWorkspace | undefined {
  const choices = businessWorkspaces();
  if (!choices.length) return undefined;
  const id = new URLSearchParams(window.location.search).get('dataWorkspace') ?? 'core';
  const selected = choices.find((w) => w.id === id);
  if (!selected) throw new Error('所选数据工作区未配置，未回退到其他数据库');
  return selected;
}

/** The platform selects only configured local services; backend session/scope checks still apply. */
export const workspaceFetch: typeof fetch = (input, init) => {
  if (typeof window === 'undefined') return globalThis.fetch(input, init);
  const url = new URL(input instanceof Request ? input.url : String(input), window.location.href);
  const selected = selectedBusinessWorkspace();
  if (
    !selected ||
    url.origin !== window.location.origin ||
    !(url.pathname.startsWith('/management/') || url.pathname.startsWith('/read-models/'))
  )
    return globalThis.fetch(input, init);
  const headers = new Headers(input instanceof Request ? input.headers : undefined);
  new Headers(init?.headers).forEach((value, key) => headers.set(key, value));
  headers.set('X-Rescue-Workspace', selected.id);
  return globalThis.fetch(input, { ...init, headers });
};
